function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clznd7ooca)",
  fill: "#757575"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.26 2.44-.612 3.71.844.26.47-2.833 2.746.846.143-.872L10.26 2.44z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.872 1.475A5.83 5.83 0 0 0 1.166 7a5.83 5.83 0 0 0 5.828 5.833A5.837 5.837 0 0 0 12.833 7c0-1.64-.678-3.122-1.77-4.182l-.628 1.023A4.665 4.665 0 0 1 7 11.667 4.665 4.665 0 0 1 2.332 7a4.665 4.665 0 0 1 5.909-4.5l.63-1.025zM6.416 4.083h.875v3.063l2.625 1.557-.437.718-3.063-1.838v-3.5z"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clznd7ooca"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})));
function SvgLastReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastReview);
export default __webpack_public_path__ + "static/media/last-review.d5665ceb90f2b25408e4a06e32905188.svg";
export { ForwardRef as ReactComponent };